import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as pageServices from "../../../services/pages.services";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_50, MENU_LOCATION, showFilterlist } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const PageEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation()

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_pages"), url: "/admin/cms/pages/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    pageServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data?.data ? data.data : []);
        // console.log("data--->", data.data);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (<Formik
        enableReinitialize
        initialValues={{
          title: showdefault && showdefault.title ? showdefault.title : "",
          slug: showdefault && showdefault.slug ? showdefault.slug : "",
          status:
            showdefault && String(showdefault.status) ? showdefault.status : "",
          menu_location:
            showdefault && showdefault.menu_location ? showdefault.menu_location : "",
          show_in_footer:
            showdefault && showdefault.show_in_footer !== undefined ? showdefault.show_in_footer : true,
          short_description: showdefault && showdefault.short_description ? showdefault.short_description : "",
          richtext:
            showdefault && showdefault.description
              ? showdefault.description
              : "",
        }}
        validate={(values) => {
          const error = {};
        
          // Trim all necessary string fields first
          const title = values.title?.trim() || "";
          const slug = values.slug?.trim() || "";
          const short_description = values.short_description?.trim() || "";
          const richtext = values.richtext;
        
          // Title Validation
          if (!title) error.title = t("label_title_error");
          else if (title.length > INPUT_LENGTH_50)
            error.title = t("validation_err_reached_maximum_length");
        
          // Slug Validation
          if (!slug) error.slug = t("label_slug_error");
          else if (slug.length > INPUT_LENGTH_50)
            error.slug = t("validation_err_reached_maximum_length");
        
          // Status Validation
          if (!values.status) error.status = t("validation_err_status_required");
        
          // Menu Location Validation
          if (!values.menu_location) error.menu_location = t("validation_err_menu_location");
        
          // Short Description Validation
          if (!short_description) error.short_description = t("label_short_description_error");
        
          // Rich Text Validation
          if (!richtext) error.richtext = t("label_long_description_error");
        
          return error;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          globalLoader(true);
          let formData = new FormData();
          formData.append("o_id", params.id);
          formData.append("title", values.title);
          formData.append("slug", values.slug);
          formData.append("status", values.status);
          formData.append("menu_location", values.menu_location);
          formData.append("show_in_footer", values.show_in_footer);
          formData.append("short_description", values.short_description);
          formData.append("description", values.richtext);
          pageServices
            .Edit(formData)
            .then((response) => {
              setSubmitting(false);
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                if (saveType !== "Save") {
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/cms/pages/list/1`);
                  }, 1000);
                }
                if (saveType === "Save") {
                  setTimeout(() => {
                    globalLoader(false);
                  }, 1000);
                }
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
              }
            })
            .catch((error) => {
              console.log("error ====> ", error);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="main-content-label mb-3">{t("edit_cms")}</h6>
                    </div>
                    {showdefault && Object.keys(showdefault).length > 0 ? (
                      <div className="row row-sm">

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("Title")}:<span className="requirestar">*</span>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            name="title"
                            id="title"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder="Enter title"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title && touched.title && errors.title}
                          </span>
                        </div>
    
                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="slug" className="text-left d-flex">
                            {t("label_slug_of_page")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="slug"
                            id="slug"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.slug}
                            disabled={"disabled"}
                            className="form-control"
                            placeholder="Enter slug of the page"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.slug && touched.slug && errors.slug}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >

                              {/* <option value="">{t("input_select_text")}</option> */}
                              {(showFilterlist).map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.status &&
                              touched.status &&
                              errors.status}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="menu_location" className="text-left d-flex">
                            {t("label_menu_of_the_page")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="menu_location"
                              id="menu_location"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.menu_location}
                              className="form-control" >

                              <option value="">{t("input_select_text")}</option>
                              {Object.keys(MENU_LOCATION).map((key, i) => {
                                return (
                                  <option key={i} value={MENU_LOCATION[key]}>{t(`${key}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.menu_location &&
                              touched.menu_location &&
                              errors.menu_location}
                          </span>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="show_in_footer" className="text-left d-flex mb-2">
                            {t("label_show_in_footer")}:
                          </label>
                          <div className="d-flex align-items-center">
                            <label
                              htmlFor="show_in_footer"
                              style={{
                                position: 'relative',
                                display: 'inline-block',
                                width: '52px',
                                height: '28px',
                                cursor: 'pointer',
                                flexShrink: 0,
                              }}
                            >
                              <input
                                type="checkbox"
                                id="show_in_footer"
                                name="show_in_footer"
                                checked={values.show_in_footer}
                                onChange={(e) => {
                                  setFieldValue("show_in_footer", e.target.checked);
                                }}
                                style={{ opacity: 0, width: 0, height: 0, position: 'absolute' }}
                              />
                              <span
                                style={{
                                  position: 'absolute',
                                  inset: 0,
                                  borderRadius: '34px',
                                  backgroundColor: values.show_in_footer ? '#0d6efd' : '#ccc',
                                  transition: 'background-color 0.3s ease',
                                }}
                              />
                              <span
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  left: values.show_in_footer ? '26px' : '4px',
                                  width: '20px',
                                  height: '20px',
                                  borderRadius: '50%',
                                  backgroundColor: '#fff',
                                  boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                                  transition: 'left 0.3s ease',
                                }}
                              />
                            </label>
                            <span className="ms-2" style={{ fontWeight: 500, fontSize: '0.95rem', color: values.show_in_footer ? '#0d6efd' : '#6c757d' }}>
                              {values.show_in_footer ? t("label_yes") : t("label_no")}
                            </span>
                          </div>
                        </div>

                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_tags"
                            className="text-left d-flex"
                          >
                             {t("meta_tags")}:{" "}
                          </label>
                          <textarea
                            name="meta_tags"
                            id="meta_tags"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_tags}
                            className="form-control"
                          />
                        </div> */}
                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_keyword"
                            className="text-left d-flex"
                          >
                             {t("meta_keywords")}:{" "}
                          </label>
                          <textarea
                            name="meta_keyword"
                            id="meta_keyword"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_keyword}
                            className="form-control"
                          />
                        </div> */}
                        <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="short_description"
                            className="text-left d-flex"
                          >
                            {t("Short Description")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="short_description"
                            id="short_description"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.short_description}
                            className="form-control"
                            placeholder="Enter short description"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.short_description &&
                              touched.short_description &&
                              errors.short_description}
                          </span>
                        </div>
        
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="subject" className="text-left d-flex">
                            {t("Long Description")}:<span className="requirestar">*</span>
                          </label>
                          {dataLoaded ? (
                            <CustomCkeditor
                              fieldname={"richtext"}
                              setFieldValue={setFieldValue}
                              value={values.richtext}
                              setFieldTouched={setFieldTouched}
                            />
                          ) : ""}

                          <span className="text-danger d-flex text-left">
                            {errors.richtext &&
                              touched.richtext &&
                              errors.richtext}
                          </span>
                        </div>

                    
                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
      ) : (
        <Loader />
      )}

    </>
  );
};

export default PageEdit;
